import { type NavigateFunction } from "react-router/dist/lib/hooks"
import { type Dispatch } from "redux"

import { ROLE_IDS } from "../../../constants/roles.ts"
import { RoutesPaths } from "../../../constants/routes.ts"
import { request } from "../../../services/api.ts"
import { handleGetResponseData } from "../../../utils/handlers/handle-get-response-data"
import utils from "../../../utils/utils"
import type { UserInfo } from "../types/auth.types.ts"

interface HandlePostLoginNavigationParams {
  dispatch: Dispatch
  navigate: NavigateFunction
  userInfo?: UserInfo
  redirect?: string | null
}

export const handlePostLoginNavigation = async ({
  dispatch,
  navigate,
  userInfo,
  redirect = null
}: HandlePostLoginNavigationParams) => {
  if (redirect && userInfo?.role?.name !== "Admin") {
    let decodedNextUrl
    try {
      decodedNextUrl = decodeURIComponent(redirect)
    } catch (e) {
      console.error("Error decoding nextUrl:", e)
      decodedNextUrl = redirect
    }

    const responseData = await request.api.post(decodedNextUrl, {
      maxRedirects: 0,
      validateStatus: (status: number) => status >= 200 && status < 400
    })
    const responseOauth = handleGetResponseData(responseData)

    if (responseOauth?.data?.redirect_uri) {
      return dispatch(utils.goLink(responseOauth?.data?.redirect_uri) as any)
    }
  }

  const isCustomer = userInfo?.role?.id === ROLE_IDS.CUSTOMER
  const landing = isCustomer ? RoutesPaths.portal.home : RoutesPaths.home

  if (userInfo?.role?.name !== "Admin" && userInfo?.["email_added"]) {
    // const reference = historyLocal?.location?.state?.reference
    // if (reference) {
    //   dispatch(replace(reference))
    // } else {
    //   dispatch(push(RoutesPaths.home))
    // }
    navigate(landing)
  } else if (userInfo?.role?.name === "Admin") {
    navigate(landing)
  } else if (!userInfo?.["email_added"]) {
    navigate(RoutesPaths.auth.addEmail)
  }
}
